































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import RunScriptDataSection from "./RunScriptDataSection.vue";
import { onMounted, ref } from "@vue/composition-api";
import { UseLoading } from "@/common/composition/loading";
import { get_finding_counts } from "@/common/api/findings/findings.api";
import { PlaybookDataDescriptor } from "../data/model";
import { FindingsResultMap } from "../data/playbook-findings-result.map";
import { FindingType } from "@/common/api/findings/findings.model";
export default Vue.extend({
  components: {
    Modal,
    RunScriptDataSection,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "70rem",
      withTopRightCloseBtn: true,
    };

    const total_count = ref(0);
    const success_count = ref("");
    const failure_counts = ref([] as string[]);

    const [is_loading, set_is_loading] = UseLoading().as_arr();

    const set_count_in_template = (template: string, count: number) => {
      template = template.replace("{count}", count + "");
      if (count == 1) {
        template = template.replace("files", "file");
      }
      return template;
    };

    onMounted(async () => {
      set_is_loading(true);
      // @ts-ignore
      const instance: PlaybookDataDescriptor = props.modalData.instance;
      console.log("instance::", instance);
      const {
        runtimeScope: { serviceId, sessionId, appId },
        scope: { labelIds, itemsCount },
      } = instance;
      const result_findings_arr = FindingsResultMap[instance.playbookId];
      const [success_item, ...err_items] = result_findings_arr.findings;

      total_count.value = itemsCount;
      const res = await get_finding_counts({
        // @ts-ignore
        application: appId,
        cursor: "",
        // @ts-ignore
        service: serviceId,
        types: result_findings_arr.findings.map((d) => d[0]),
        label_ids: labelIds,
        axis_z: {
          type: "Session",
          value: sessionId,
        },
      });
      if (res.success) {
        console.log("RESSSS:", res.value);
        const result: Array<{
          labelId: string;
          count: number;
          findingType: FindingType;
        }> = res.value;

        const success_res = result.find(
          (d) => d.findingType === success_item[0]
        );

        success_count.value = success_res
          ? set_count_in_template(success_item[1], success_res.count)
          : set_count_in_template(success_item[1], 0);

        const gap_count =
          total_count.value -
          result.reduce((acc, d) => {
            acc += d.count;
            return acc;
          }, 0);

        failure_counts.value = result
          .filter((f) => err_items.map((d) => d[0]).includes(f.findingType))
          .map((d) => {
            const sentence = err_items
              .find((f) => f[0] === d.findingType)![1]
              .replace("{count}", d.count + "");
            if (d.count == 1) {
              return sentence.replace("files", "file");
            }
            return sentence;
          });

        if (gap_count > 0) {
          failure_counts.value = [
            ...failure_counts.value,
            set_count_in_template(result_findings_arr.gap, gap_count),
          ];
        }
      }
      set_is_loading(false);
    });

    return {
      config,
      is_loading,
      failure_counts,
      success_count,
      total_count,
    };
  },
});
